import type { GameDescriptor } from '../game-registry.js';
import { DiceScene } from '../scenes/DiceScene.js';

export const diceDescriptor: GameDescriptor = { code: 'dice', scene: DiceScene, supportsAuto: true, selectable: true };
